import {Component} from 'react';
import {ModelAides,getDroitsAvailable,traitementAidesCategories} from './lib/droits.js';
import {DroitCell} from './droit-cell';
import Espacemembre from './espacemembre';
import AidesVelo from './aidesvelo';

class Resultats extends Component {

	constructor(props){
		super(props);
		this.state = {
			results: {},
			droitsBeneficiable :[],
			aidesParCategories :{},
			loading: true,
			categoriesClass :{
				"Aide(s) Juridique": "aides-juridiques",
				"Aide(s) au logement": "aides-logement",
				"Aide(s) aux loisirs": "aides-loisirs",
				"Aide(s) aux transports": "aides-transports",
				"Aide(s) à l'insertion professionnelle": "aides-professionnelle",
				"Aide(s) à la santé": "aides-sante",
			}

		}
		
		var entities = {};
		Object.keys(ModelAides).forEach( (droit)=>{
			entities[droit.entity]= null;
		});

        entities = { ...entities , ...this.props };
        entities.demandeur.rfr = null;
        // test rfr
        if ( entities.conjoint && Object.keys(entities.conjoint).length > 0 ) {
            entities.famille.parents = ['individu', 'conjoint'];
            entities.menage.conjoint = ['conjoint'];
            entities.foyer_fiscal.declarants =['individu', 'conjoint'];
        }
        
        entities.foyer_fiscal.personnes_a_charge=[];
        entities.menage.enfants=[];
        entities.famille.enfants=[];
        entities.menage.cheque_energie = null;


        Object.keys(entities.individus).forEach ((individu)=>{
            if ( individu !== 'demandeur' && individu !== 'conjoint' ) {
                entities.foyer_fiscal.personnes_a_charge.push(individu);
                entities.menage.enfants.push(individu);
                entities.famille.enfants.push(individu);
            }
        });
        /* Variable logement conventionne menage */
        entities.menage.logement_conventionne =
          entities.menage.statut_occupation_logement &&
          entities.menage.statut_occupation_logement === 'primo_accedant' &&
          entities.menage.loyer &&
          entities.menage.loyer === 0; 



        /* mettre les infos velo dans un state et enlever des entities parce que ca polue les infos.*/
            const prixVelo = entities.demandeur.prixVelo;
            const typeVelo = entities.demandeur.typeVelo;
            const regionCode = entities.menage.regionCode;
            const codePostal = entities.menage.code_postal;
            const codeEpci = entities.menage.codeEpci;
            const codeInsee = entities.menage.depcom;
            const siren = entities.menage.siren;
            const nom =  entities.menage.nomVille;
            const rfrParPart = entities.demandeur.rfrParPart

            this.state.d = {
                "velo" : { 
                    "type" : typeVelo,
                    "price" : prixVelo,
                },
                "localite" : nom,
                "codeInsee" : codeInsee,
                "nom" : nom, 
                "codeEpci" : codeEpci ,
                "siren" : siren ,
                "region": regionCode,
                "rfr" : rfrParPart,
                "codePostal" : entities.menage.code_postal
            }

        
        delete entities.demandeur.date_fin_contrat;
        entities.foyer_fiscal.rfr = null;
        if ( typeof entities.conjoint !== 'undefined' ){
            entities.conjoint.statut_marital = entities.demandeur.statut_marital;
        }
        const requestURI = "https://simulateurs.aide-sociale.fr/simulateur-backend-test/index.php" ;

        var data = {
            'individus':  {
                ...entities.individus
                ,...{
                    'individu' : entities.demandeur,
                    'conjoint' : entities.conjoint,
                }
            },
            'familles' : {
                _ : entities.famille, 
            },
            'foyers_fiscaux' : {
                _ : entities.foyer_fiscal,
            },
            'menages': {
                _ : entities.menage,
            }
        };


        data.menages._.aide_logement_date_pret_conventionne = (new Date().getFullYear() - 4).toString() + '-12-31';

        this.state.recap_situation = data;
        this.state.unparsedData = {
            individus :{
                ...entities.individus
                ,...{
                    'individu' : entities.demandeur,
                    'conjoint' : entities.conjoint,
                }
            },
            famille : entities.famille,
            foyer_fiscal : entities.foyer_fiscal,
            menage : entities.menage

        };
        if ( entities.demandeur.nationalite === undefined ) {
            this.state.unparsedData.individus.individu.nationalite = 'FR';
        }
        if ( this.state.unparsedData.menage.statut_occupation_logement === undefined) {
            this.state.unparsedData.menage.statut_occupation_logement = 'sans_domicile';
        }

        Object.keys(data).forEach( (entity)=>{
            data[entity] = JSON.stringify(data[entity]);
        });
        
        const request = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin' : '*',
            },

            body:JSON.stringify(data)
        };

        fetch(requestURI ,request)
            .then((res)=> {
                return res.json();
            })
            .then ((json)=>{
                this.state.results = json;
                var definedRessources = [];
                if ( typeof this.props.definedRessources !== 'undefined' && this.props.definedRessources !== null){
                    (Object.keys(this.props.definedRessources).forEach((i)=>{return definedRessources.push(this.props.definedRessources[i]);}));
                }
                this.state.droitsBeneficiable = getDroitsAvailable(this.state.results.openfisca,definedRessources);
                this.state.aidesParCategories = traitementAidesCategories(JSON.parse(this.state.results.as_api));

                this.saveResultEspaceMembre();

                this.setState( {loading:false});
            });

        

    }

    saveResultEspaceMembre = () => {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let email = window.email;
        let situationIdRemote = window.situationId;
        let isMember = email && situationIdRemote;
        if ( isMember ) {
            
            // Preparing  data for requset .
            const data_api ={
                'id': situationIdRemote,
                'email': email ,
                'droits':  JSON.stringify(this.parseDataDroitsEspaceMembre()),
                'aide_soc_json' : this.state.results.as_api,
                'situation' : JSON.stringify(this.state.unparsedData),
            };

            // Preparing request . 
            const request = {
                    method:'POST',
                    headers: {
                      'Content-Type' : 'Application/json',
                    },
                    body: JSON.stringify(data_api),
            };

            const saveResult = "https://aide-sociale.fr/espacemembre/public/api/save-result" ;
            // Send data for current user.
            fetch( saveResult , request)
              .then((res)=>{
                  console.log(res);
              }).catch((err) => {
                console.error(err);
              });
        }
    }

    parseDataDroitsEspaceMembre = () => {
        let dataDroits = {};
        this.state.droitsBeneficiable.forEach( (droit)=> {
            
            dataDroits[droit.nom] = droit;
            dataDroits[droit.nom].image = "./assets/img/"+ droit.imgSrc;
            dataDroits[droit.nom].isbool = droit.type === "boolean";
            dataDroits[droit.nom].unit = droit.unit === undefined ? '€' :droit.unit;
        });
        return [dataDroits];
    }

    connect = (email , password) => {
        const connectionUrl = 'https://aide-sociale.fr/espacemembre/public/loginfromoutside';
        

        fetch("https://aide-sociale.fr/espacemembre/public/token")
            .then( (res)=>{
                return res.body.getReader().read()

            })
            .then( (uint8array)=> {
                let decoder = new TextDecoder();
                let token = decoder.decode(uint8array.value);                

                const data = {
                    "email" : email ,
                    "password":password,
                    "droits":JSON.stringify(this.parseDataDroitsEspaceMembre()),
                    "aide_soc_json": this.state.results.as_api,
                    "situation" : JSON.stringify(this.state.unparsedData),
                    "_token" : token,
                };

                const request = {
                    method:'POST',
                    headers: {
                      'Content-Type' : 'Application/json',
                      'Access-Control-Allow-Origin' : '*',
                        'X-CSRF-TOKEN': token
                    },
                    body: JSON.stringify(data),
                };

                let loginUrl = "https://aide-sociale.fr/espacemembre/public/loginfromoutside?password="+password+'&email='+email;
                window.open(loginUrl , '_blank');

                fetch(connectionUrl , request)
                    .then((response)=>{
                        return response.body.getReader().read();
                    })
                    .then( (uint8array) =>{
                        return new TextDecoder().decode(uint8array.value);
                    })
                    .then( (res)=>{
                        let message = JSON.parse(res);

                        if (typeof message.error !== 'undefined' ){
                            this.setState( {feedbackEspacemembre : message.error});
                        } else {
                            this.setState( {
                                feedbackEspacemembre : <p>Si vous n'avez pas été redirigé automatiquement veuillez cliquer <a href="https://aide-sociale.fr/espacemembre/public/result">ici</a></p>
                            });
                        }
                    })
                    .catch( (response)=>{
                        console.error(response);
                          var loginErrors = <p>Si vous n'avez pas été redirigé automatiquement veuillez cliquer <a href="https://aide-sociale.fr/espacemembre/public/result" target="_blank">ici</a></p>;
                          if ( response.status == 422 ) {
                              data = response.body.getReader.read()
                                  .then((res)=>{
                                      return JSON.parse( new TextDecoder().decode(res.value));
                                  });
                              loginErrors = data.errors;
                          }
                          else if (response.status == 419){
                            if ( response.data.message == "CSRF token mismatch.") {
                               loginErrors = " Vous êtes deja connecter";
                            }
                          }
                          /* Internal Server Error*/
                          else if ( response.status == 500 ){
                             loginErrors = 'Une Erreur est survenu lors de la géstion de votre requete';
                          }
                          this.setState({feedbackEspacemembre: {message :loginErrors}});
                    });
            });
    }
    
    subscribe = (email) => {
        const subscribeUrl= "https://aide-sociale.fr/espacemembre/public/api/register-optin-user";

        const data = {
            "email" : email ,
            "droits": JSON.stringify(this.parseDataDroitsEspaceMembre()),
            "aide_soc_json": this.state.results.as_api,
            "situation" : JSON.stringify(this.state.unparsedData)
        };

        const request = {
            method: 'POST',
            headers: {
              'Content-Type': 'Application/json',
              'Access-Control-Allow-Origin' : '*',
            },
            body:JSON.stringify(data),
        };


        this.setState({feedbackEspacemembre:{load:true}});



        fetch(subscribeUrl ,request)
            .then((response)=>{
                return response.body.getReader().read();
            })
            .then( (uint8array) =>{
                return new TextDecoder().decode(uint8array.value);
            })
            .then( (res)=>{
                let message = JSON.parse(res);

                if (typeof message.error !== 'undefined' ){
                    this.setState( {feedbackEspacemembre : {error: true , message : message.error}});
                } else {
                    this.setState(
                    {feedbackEspacemembre :
                      {
                        error: false,
                        message : "Un e-mail vous a été envoyé avec un lien pour vous connecter à votre espace membre.",

                      }
                    });

                    console.log('brevo stats-report');
					// Sendinblue
					fetch ( 'https://www.aide-sociale.fr/simulateur/stats-report.php' , 
						{
		      				'Access-Control-Allow-Origin' : '*',
					        "method":'POST',
					        "body": JSON.stringify(data)
				     	}
				    );
				}
			})
			.catch((error)=>{
				console.error(error);
			});
	}

    restart = ()=>{
        this.props.restart();
    }

    render(){
        var i = 0;
        const currentYear = new Date().getFullYear();
        const [anneeN2 , anneeN1] = [currentYear-2 , currentYear-1];
        const isActif  = this.props.demandeur.activite === "actif";

		return <div className="step-inner-container">
			
			{ ( this.state.loading ) ?
				<>
				  <div className="loader"></div>
				  <p className="text-center">Chargement des résultats...</p>
				</>
				: <div className="resultats">
					<Espacemembre 
						connect={this.connect}
						subscribe={this.subscribe} 
						feedback={this.state.feedbackEspacemembre}
					/>
					<div className="notice">
						<p>Nous avons supposé que vos ressources pour l'année {anneeN2} étaient les mêmes qu'entre décembre {anneeN1} et décembre {currentYear}.</p>
						<button onClick={this.props.validateStep}>Déclarer vos ressources {anneeN2}</button>
					</div>
					<div className="information">
					  <p>Selon les renseignements que vous avez saisis, vous êtes, a priori en situation de bénéficier des aides suivantes.
					  Les montants ne sont donnés qu’à titre indicatif et sont arrondis.</p>
					</div>
					<div className="categorie aides-principaux">
					  <h4>Aides principales</h4>
					  {this.state.droitsBeneficiable.map( ( droit)=>(
					  	  (droit.nom === "garantie_jeunes" && isActif) ? '' : <DroitCell model={droit} localImg={true} key={i++} />
					  	)
					  )}
					</div>
					<hr className="droit-separation"/>
				{ Object.keys(this.state.aidesParCategories).map( (categorie)=>(
					<>
					 <div className="categorie">
						<h4>{categorie}</h4>
						{this.state.aidesParCategories[categorie].map( (droit)=>(
							<DroitCell model={droit} key={i++} categorie={this.state.categoriesClass[categorie]}/>
						))}
					</div>
					<hr className="droit-separation"/>
                    {
                        (categorie === "Aide(s) aux transports") ? 
                        <AidesVelo  d={this.state.d}/>  : ''
                    }
					</>
				))}


				<div className="result-button button-container previous">
						<button onClick={this.restart}> Recommencer </button>
				</div>


                </div>} 
        </div>
    }
}


export default Resultats;
